<form class="card mt-2">
  <div class="card-body">
    <div class="float-right" *ngIf="canEdit">
      <button (click)="openScanEquipment()" class="btn btn-secondary mr-2 mt-1">Scan</button>
      <button (click)="openAssignEquipment()" class="btn btn-primary mr-2 mt-1">Assign Asset</button>
      <button (click)="openReturnEquipment()" class="btn btn-primary mt-1">Return Asset</button>
    </div>
    <h2 class="mb-3">Asset Tracker</h2>

    <div class="row mb-3">
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Items</label>
        <p-select styleClass="app-select w-100" [options]="assignmentStateOptions" [(ngModel)]="filterAssignmentState" [ngModelOptions]="{standalone: true}"></p-select>
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Assigned To</label>
        <p-select styleClass="app-select w-100" [options]="usersList" [(ngModel)]="filterAssignedToUserID" [filter]="true" [resetFilterOnHide]="true" [ngModelOptions]="{standalone: true}" placeholder="Select user..."></p-select>
        <div style="font-size:.75rem;" class="mt-2">
          <label for="includeTerminatedUsers">Include Separated Employees: </label>
          <p-checkbox id="includeTerminatedUsers" name="includeTerminatedUsers" styleClass="form-check-input ml-4" [(ngModel)]="includeTerminated" (onChange)="includeTerminatedChange($event)" [ngModelOptions]="{standalone: true}" [binary]="true"></p-checkbox>
        </div>
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Type</label>
        <p-select styleClass="app-select w-100" [filter]="true" [resetFilterOnHide]="true" [options]="equipmentTypes" [(ngModel)]="filterTypeId" [ngModelOptions]="{standalone: true}"></p-select>
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Category</label>
        <input type="text" class="form-control" placeholder="Category..." [(ngModel)]="filterAssetCategory" [ngModelOptions]="{standalone: true}" />
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Description</label>
        <input type="text" class="form-control" placeholder="Description..." [(ngModel)]="filterDescription" [ngModelOptions]="{standalone: true}" />
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Serial</label>
        <input type="text" class="form-control" placeholder="Serial..." [(ngModel)]="filterSerialNumber" [ngModelOptions]="{standalone: true}" />
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Barcode</label>
        <input type="text" class="form-control" placeholder="Barcode..." [(ngModel)]="filterBarcode" [ngModelOptions]="{standalone: true}" />
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Assigned From/Main Location</label>
        <input type="text" class="form-control" placeholder="Assigned from or current location..." [(ngModel)]="filterLocation" [ngModelOptions]="{standalone: true}" />
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Expected Return Date</label>
        <input type="date" class="form-control" [(ngModel)]="filterReturnDate" [ngModelOptions]="{standalone: true}" />
      </div>
      <div class="col-12 col-xl-3 mb-2">
        <label class="small text-muted mb-1">Group</label>
        <p-select styleClass="app-select w-100"
                  [options]="groupFilterOptions"
                  [(ngModel)]="filterGroup"
                  [ngModelOptions]="{standalone: true}"></p-select>
      </div>
      <div class="col-12 mb-2">
        <div class="ui-column-buttons">
          <div>Display:</div>
          <div>
            <button type="button" (click)="editColumns('assignedTo')" [style.background-color]="!isColumnVisible('assignedTo') ? 'white' : 'lightgrey'">Assigned&nbsp;To</button>
            <button type="button" (click)="editColumns('grouped')" [style.background-color]="!isColumnVisible('grouped') ? 'white' : 'lightgrey'">Grouped</button>
            <button type="button" (click)="editColumns('type')" [style.background-color]="!isColumnVisible('type') ? 'white' : 'lightgrey'">Type</button>
            <button type="button" (click)="editColumns('category')" [style.background-color]="!isColumnVisible('category') ? 'white' : 'lightgrey'">Category</button>
            <button type="button" (click)="editColumns('description')" [style.background-color]="!isColumnVisible('description') ? 'white' : 'lightgrey'">Description</button>
            <button type="button" (click)="editColumns('serial')" [style.background-color]="!isColumnVisible('serial') ? 'white' : 'lightgrey'">Serial</button>
            <button type="button" (click)="editColumns('barcode')" [style.background-color]="!isColumnVisible('barcode') ? 'white' : 'lightgrey'">Barcode</button>
            <button type="button" (click)="editColumns('location')" [style.background-color]="!isColumnVisible('location') ? 'white' : 'lightgrey'">Assigned&nbsp;From&nbsp;/&nbsp;Current&nbsp;Location</button>
            <button type="button" (click)="editColumns('returnDate')" [style.background-color]="!isColumnVisible('returnDate') ? 'white' : 'lightgrey'">Expected&nbsp;Return&nbsp;Date</button>
            <button type="button" (click)="editColumns('returned')" [style.background-color]="!isColumnVisible('returned') ? 'white' : 'lightgrey'">Returned</button>
            <button type="button" (click)="editColumns('status')" [style.background-color]="!isColumnVisible('status') ? 'white' : 'lightgrey'">Status</button>
            <button type="button" (click)="editColumns('assignSigned')" [style.background-color]="!isColumnVisible('assignSigned') ? 'white' : 'lightgrey'">Assign&nbsp;Signed</button>
          </div>
        </div>
      </div>
      <div class="col-12 mb-2 d-flex align-items-end justify-content-end filter-actions">
        <button type="button" class="btn btn-secondary mr-2" (click)="clearFilters()">Clear</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Filter</button>
      </div>
    </div>

    <i *ngIf="loadingAssignedEquipmentList" class="material-icons rotate text-muted">loop</i>
    <p-table [value]="equipments?.result" [responsive]="true" styleClass="equipment-list-table"
             [paginator]="true" [paginatorPosition]="'bottom'" [(rows)]="rowsAmount" [rowsPerPageOptions]="[10, 25, 50, 100, 500, { showAll: 'All' }]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
             [totalRecords]="equipments?.totalRecords" [lazy]="true"
             (onLazyLoad)="loadPage($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="140px"></th>
          <th *ngIf="isColumnVisible('assignedTo')" [pSortableColumn]="'assignedToUserName'">Assigned To <p-sortIcon [field]="'assignedToUserName'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('grouped')" [pSortableColumn]="'isGrouped'">Group <p-sortIcon [field]="'isGrouped'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('type')" [pSortableColumn]="'assetType'">Type <p-sortIcon [field]="'assetType'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('category')" [pSortableColumn]="'assetCategory'">Category <p-sortIcon [field]="'assetCategory'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('description')" [pSortableColumn]="'description'">Description <p-sortIcon [field]="'description'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('serial')" [pSortableColumn]="'serialNumber'">Serial <p-sortIcon [field]="'serialNumber'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('barcode')" [pSortableColumn]="'barcode'">Barcode <p-sortIcon [field]="'barcode'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('location')" [pSortableColumn]="'inventoryAssetLocation'">Assigned From/Main Location <p-sortIcon [field]="'inventoryAssetLocation'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('returnDate')" [pSortableColumn]="'returnDate'">Expected Return Date <p-sortIcon [field]="'returnDate'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('returned')" [pSortableColumn]="'dateReturned'">Returned <p-sortIcon [field]="'dateReturned'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('status')" [pSortableColumn]="'assetStatus'">Status <p-sortIcon [field]="'assetStatus'"></p-sortIcon></th>
          <th *ngIf="isColumnVisible('assignSigned')" [pSortableColumn]="'assignSigned'">Assign Signed <p-sortIcon [field]="'assignSigned'"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-equipment>
        <tr>
          <td>
            <button class="btn btn-secondary mr-2 mb-2" *ngIf="canReturn(equipment)" (click)="openReturnEquipment(equipment)" title="Return Asset">
              <i class="fas fa-undo"></i>
            </button>
            <button class="btn btn-secondary mr-2 mb-2" *ngIf="canAssign(equipment)" (click)="openAssignEquipmentForItem(equipment)" title="Assign Asset">
              <i class="fas fa-user-plus"></i>
            </button>
          </td>
          <td *ngIf="isColumnVisible('assignedTo')">
            {{getAssignedToLabel(equipment)}}
          </td>
          <td *ngIf="isColumnVisible('grouped')">{{getGroupDisplay(equipment)}}</td>
          <td *ngIf="isColumnVisible('type')">
            {{equipment.equipment.type}}
          </td>
          <td *ngIf="isColumnVisible('category')">
            {{equipment.equipment.assetCategory || '-'}}
          </td>
          <td *ngIf="isColumnVisible('description')">
            {{equipment.equipment.description}}
          </td>
          <td *ngIf="isColumnVisible('serial')">
            {{equipment.equipment.serialNumber || '-'}}
          </td>
          <td *ngIf="isColumnVisible('barcode')">
            {{equipment.equipment.barcode || '-'}}
          </td>
          <td *ngIf="isColumnVisible('location')">
            {{equipment.lastAssignedEquipment?.inventoryAssetLocation || equipment.equipment.inventoryAssetLocation || '-'}}
          </td>
          <td *ngIf="isColumnVisible('returnDate')">
            {{equipment.lastAssignedEquipment?.returnDate | date:'shortDate' }}
          </td>
          <td *ngIf="isColumnVisible('returned')">
            <ng-container *ngIf="hasReturnedDetails(equipment); else noReturnDetails">
              <div class="small">Date: {{equipment.lastAssignedEquipment?.dateReturned | date:'shortDate'}}</div>
              <div class="small">Returned by: {{getReturnedByLabel(equipment)}}</div>
              <div class="small">
                Status:
                <span [class.text-success]="isGoodReturnStatus(equipment)"
                      [class.text-warning]="isDamagedReturnStatus(equipment)"
                      [class.text-danger]="!isGoodReturnStatus(equipment) && !isDamagedReturnStatus(equipment)">
                  {{equipment.lastAssignedEquipment?.returnStatus || '-'}}
                </span>
              </div>
              <div class="small" *ngIf="equipment.lastAssignedEquipment?.returnNotes">Notes: {{equipment.lastAssignedEquipment?.returnNotes}}</div>
            </ng-container>
            <ng-template #noReturnDetails>-</ng-template>
          </td>
          <td *ngIf="isColumnVisible('status')">
            {{equipment.lastAssignedEquipment?.assetStatus || '-'}}
          </td>
          <td *ngIf="isColumnVisible('assignSigned')">
            {{getAssignSignedDisplay(equipment)}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</form>

<p-dialog *ngIf="displayAssignEquipment" header="Assign Asset" [focusTrap]="false" [modal]="true" appendTo="body" [styleClass]="'top-dialog'"
          [style]="{width: '95vw'}" [(visible)]="displayAssignEquipment">
  <app-assign-equipment></app-assign-equipment>
</p-dialog>

<p-dialog header="Return Asset" [modal]="true" appendTo="body" [styleClass]="'top-dialog overflow-visible return-asset-dialog'"
          [style]="{width: '95vw'}" [(visible)]="displayReturnEquipment">
  <app-return-equipment
    *ngIf="displayReturnEquipment"
    [initialUserID]="returnDialogUserID"
    [initialProgramID]="returnDialogProgramID"
    [initialAssetAssignedID]="returnDialogAssetAssignedID"
    [initialSelection]="returnDialogInitialSelection"
    [selectionKey]="returnDialogSelectionKey">
  </app-return-equipment>
</p-dialog>

<p-dialog header="Scan Asset Barcode" [modal]="true" appendTo="body" [style]="{width: '900px', maxWidth: '96vw'}"
          [(visible)]="displayScanEquipment" (onHide)="onScanDialogHide()">
  <div class="row">
    <div class="col-8">
      <textarea rows="4"
             class="form-control"
             [(ngModel)]="scanBarcode"
             (ngModelChange)="scanRows = []"
             [ngModelOptions]="{standalone: true}"
             placeholder="Scan one barcode per line"></textarea>
    </div>
    <div class="col-4 text-right">
      <button type="button" class="btn btn-primary" (click)="applyScanSearch()" [disabled]="scanLoading">Search</button>
    </div>
  </div>
  <div class="mt-2 text-danger" *ngIf="scanError">{{scanError}}</div>
  <small class="text-muted">Scan several barcodes, then search once. Scanner Enter separates codes.</small>
  <div class="mt-2 text-muted" *ngIf="scanLoading">Looking up scanned assets...</div>
  <div class="card mt-2" *ngFor="let row of scanRows">
    <div class="card-body py-2">
      <b>{{row.barcode}}</b><span *ngIf="row.count > 1" class="ml-2">Scanned {{row.count}} times</span>
      <div class="text-danger" *ngIf="!row.matches.length">Asset not found or not accessible.</div>
      <div class="text-warning" *ngIf="row.matches.length > 1">Multiple assets or locations match this barcode.</div>
      <div class="mt-2" *ngFor="let match of row.matches">
        {{match.description}} · {{match.assetType}} / {{match.assetCategory}} · {{match.programName || 'No program'}} / {{match.inventoryAssetLocation || 'No location'}}<span *ngIf="match.inventoryAssetLocationID"> (#{{match.inventoryAssetLocationID}})</span> · {{match.assetStatus}} · {{match.assetAssignedID ? 'Assignment #' + match.assetAssignedID : (match.assetItemID ? 'Item #' + match.assetItemID : 'Inventory #' + match.assetInventoryID)}}
        <span *ngIf="match.assignedToUserName"> · Assigned to {{match.assignedToUserName}}</span>
        <span *ngIf="match.assignedToProgramName"> · Assigned to {{match.assignedToProgramName}}</span>
      </div>
    </div>
  </div>
</p-dialog>
